"use client"

import { useMediaQuery } from "@mui/material"

export default function useClientHasMouse(): boolean {
    return !useMediaQuery('@media (pointer: coarse)')
}